import { IPaginationResourceShort } from '../../props/general';
import { IVesselEngineResourceProps, IVesselEngineResourceShortProps } from '../../props/vessels/engine';
import Request from '../request';

const VesselEngineService = {
  retrieve: async (vesselId: string, qs?: string): Promise<{ data: IVesselEngineResourceShortProps[], pagination: IPaginationResourceShort }> => {
    try {
      const results = await Request.get(`/api/vessels/${vesselId}/engines?${qs || ''}`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  read: async (vesselId: string, id: string): Promise<IVesselEngineResourceProps> => {
    try {
      const results = await Request.get(`/api/vessels/${vesselId}/engines/${id}`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  create: async (vesselId: string, data: FormData): Promise<IVesselEngineResourceProps> => {
    try {
      const result = await Request.post(`/api/vessels/${vesselId}/engines`, data, 'multipart/form-data');
      return result;
    } catch (e) {
      throw e;
    }
  },
  update: async (vesselId: string, id: string, data: FormData): Promise<IVesselEngineResourceProps> => {
    try {
      const result = await Request.post(`/api/vessels/${vesselId}/engines/${id}?_method=PUT`, data, 'multipart/form-data');
      return result;
    } catch (e) {
      throw e;
    }
  }
};

export default VesselEngineService;
